/** Public Page API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {FeatureNs, ProjectNs, ScreenNs} from '@shared/types'
import type {PublicNs} from '@shared/types/public.namespace'

const api = createApi('publish')
const noToast = {showErrorOnToaster: false}

export const PublicPageApi = {
  checkToken: (data: PublicNs.CheckTokenRequest) =>
    api.post<PublicNs.CheckTokenRequest, ProjectNs.PublishProjectResponse>('validate-token', data, noToast),
  loadProjectData: (data: PublicNs.LoadProjectDataRequest) =>
    api.post<PublicNs.LoadProjectDataRequest, PublicNs.PublicProjectData>('load-project-data', data, noToast),
  loadProjectPageData: (data: PublicNs.LoadProjectDataRequest) =>
    api.post<PublicNs.LoadProjectDataRequest, FeatureNs.ProjectPage[]>('load-project-page-data', data, noToast),
  loadFeatureData: (data: PublicNs.LoadProjectDataRequest) =>
    api.post<PublicNs.LoadProjectDataRequest, FeatureNs.Feature[]>('load-feature-data', data, noToast),
  loadScreenData: (data: PublicNs.LoadProjectDataRequest) =>
    api.post<PublicNs.LoadProjectDataRequest, ScreenNs.Screen[]>('load-screen-data', data, noToast),
}
